/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proud_Acidic_Orangutan_PaveInputs */

const fr_proud_acidic_orangutan_pave = /** @type {(inputs: Proud_Acidic_Orangutan_PaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un produit`)
};

/**

* @param {Proud_Acidic_Orangutan_PaveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const proud_acidic_orangutan_pave = /** @type {((inputs?: Proud_Acidic_Orangutan_PaveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proud_Acidic_Orangutan_PaveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_proud_acidic_orangutan_pave(inputs)
});